__webpack_require__.p = "https://hattyandbarty.com/";